<!-- 备注弹窗 -->
<template>
  <!-- :getPopupContainer="triggerNode => triggerNode.parentNode" -->
  <a-popover
    :getPopupContainer="getPopupContainer"
    placement="bottomRight"
    trigger="click"
    v-model:visible="visible"
    @visibleChange="visibleChange"
    overlayClassName="remark-container"
  >
    <template #title>
      <div class="z-flex-c" style="width: 100%">
        <div>
          <span>{{ bussBar.title }}</span>
          <a-tooltip placement="topLeft">
            <template #title>
              <span>
                {{ bussBar.tips }}
              </span>
            </template>
            <auth-img :src="question" alt="" class="question" />
          </a-tooltip>
        </div>
        <a-popconfirm
          overlayClassName="remarkPopconfirm"
          :getPopupContainer="getPopupContainer"
          title="确定要清除备注吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="handleClear"
          :disabled="!bussBar.keyword"
        >
          <a-button v-if="allowClear" type="link" class="clear" :disabled="!bussBar.keyword">
            清除备注
          </a-button>
        </a-popconfirm>
      </div>
    </template>
    <template #content>
      <Textarea
        showCount
        v-model:value="bussBar.keyword"
        :maxlength="bussBar.maxLength"
        :placeholder="bussBar.placeholder"
        :rows="4"
        :autosize="false"
      />
      <div class="editor font-12-4" v-if="remarkData?.beRemarkContent">
        {{ formatDate(remarkData.changedAt, 2) }}
        {{ concatEditor(remarkData.remarkRole, remarkData.remarkName) }}
      </div>
      <div class="btn z-flex">
        <a-button @click="() => (visible = false)">取消</a-button>
        <a-button type="primary" @click="handleSave" :loading="loading">保存</a-button>
      </div>
    </template>
    <slot name="content">
      <div class="label z-flex" @click.stop>
        <span class="title">{{ bussBar.label }}</span>
        <div class="details">
          <span v-if="remarkData?.beRemarkContent">{{ remarkData.beRemarkContent }}</span>
          <div v-else class="guide">填写备注</div>
        </div>
        <auth-img :src="right" alt="" class="right" />
      </div>
    </slot>
  </a-popover>
</template>
<script setup>
import { reactive, defineProps, onMounted, ref, defineEmits } from 'vue'
import { bussConfig } from './config'
import question from '@/assets/img/work-place/question.png'
import Textarea from '@/components/cus-textarea'
import right from '@/assets/img/chat/right.png'
import useRemark from '@/views/hooks/useRemark'
import { formatDate, concatEditor } from '@/utils'
const { updatePatientRemark, updateDoctorRemark } = useRemark(prop.initParam)
const emit = defineEmits(['updateRemark'])
const visible = ref(false)
const loading = ref(false)
const prop = defineProps({
  mode: {
    type: String,
    default: 'patient'
  },
  remarkData: {
    // 协同备注
    type: Object,
    default: () => {}
  },
  allowClear: {
    // 是否允许一键清除
    type: Boolean,
    default: false
  },
  initParam: {
    // 兼容医生池的参数
    type: Object,
    default: () => {}
  },
  isRenderOnParentNode: {
    // 是否渲染在父节点上
    type: Boolean,
    default: false
  },
  patientProfileId: {
    // 就诊人id
    type: Number,
    default: 0
  }
})
const bussBar = reactive({})
const getPopupContainer = triggerNode => {
  if (prop.isRenderOnParentNode) {
    return triggerNode.parentNode
  }
  return document.body
}
// 保存医生
const handleSave = () => {
  loading.value = true
  const confirmCallback = prop.mode === 'patient' ? updatePatientRemark : updateDoctorRemark
  confirmCallback(bussBar.keyword?.trim(), prop.patientProfileId)
    .then(() => {
      visible.value = false
      emit('updateRemark')
    })
    .catch(() => {
      //
    })
    .finally(() => {
      loading.value = false
    })
}
//  清除备注
const handleClear = () => {
  bussBar.keyword = ''
  handleSave()
}
onMounted(() => {
  const config = bussConfig[prop.mode]
  Object.assign(bussBar, config)
})
const visibleChange = () => {
  const remarkData = prop.remarkData
  bussBar.keyword = remarkData?.beRemarkContent
}
</script>
<style scoped lang="scss">
.question {
  width: 16px;
  height: 16px;
  margin-left: 8px;
}
.editor {
  margin-top: 8px;
}
.btn {
  margin-top: 8px;
  justify-content: flex-end;
  align-items: center;
  .ant-btn {
    margin-left: 8px;
  }
}
.label {
  padding-top: 12px;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  cursor: pointer;
  align-items: baseline;
  justify-content: space-around;
  margin-bottom: -8px;
  .title {
    flex-shrink: 0;
    width: 72px;
  }
  .details {
    color: #333333;
    flex: 1;
    margin: 0 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
    .guide {
      text-align: right;
    }
  }
  .right {
    width: 12px;
    height: 12px;
  }
}
</style>
